/**/
/* THE SITE LIGHTBOX — extracted from product.js in.*/
/*                                                                     */
/* 🔴 WHY IT MOVED: this custom element was defined in product.js,*/
/* Which only ships with sections/main-product. The moment Calendly*/
/* Became a second consumer,*/
/* The markup rendered but the element was NEVER UPGRADED — the button*/
/* Did nothing. It stayed invisible because calendly_url was empty*/
/* Until, so the modal path had never actually been exercised*/
/* There. One lightbox means one script, loaded wherever the snippet*/
/* Renders — snippets/pdp-explorug now loads this itself, the same*/
/* Pattern as file-upload.js and faq-accordion.js.*/
/*                                                                     */
/* Depends only on global.js (whenParsed, window.trapFocus), which is*/
/* Theme-wide, so it is safe on any template.*/
/*                                                                     */
/* 🔴 job 3.2 — THE WHOLE FILE IS WRAPPED, AND THE GUARD*/
/* AT THE BOTTOM WAS NEVER ENOUGH. `snippets/pdp-explorug` loads this*/
/* Script itself, and the snippet renders more*/
/* Than once on a page: FOUR times on the PDP (View in a Room, Custom*/
/* Design Tool, the trade branch, Book a Consultation) and TWICE on*/
/* Book a Consultation v2. Two <script> tags with the same src are*/
/* Fetched once but EXECUTED twice, and a top-level `class` is a*/
/* Lexical binding in the global scope — so the second execution threw*/
/* "Identifier 'ExplorugLightbox' has already been declared" on the*/
/* PDP and the booking page, live.*/
/*                                                                     */
/* ⚠ AND `if (!customElements.get(...))` COULD NEVER HAVE HELPED: that*/
/* Is a RUNTIME check, and this is a PARSE-TIME error — the whole*/
/* Script is rejected before its first line runs. A redeclaration*/
/* Guard has to be lexical, which means a block. Inside this `if`, the*/
/* Class is block-scoped and a second load is a silent no-op.*/
/**/
if (!window.__drLightboxLoaded) {
window.__drLightboxLoaded = true;

class ExplorugLightbox extends HTMLElement {
  connectedCallback() {
    whenParsed(() => this.init());
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;
    this.dialog = this.querySelector('[data-lightbox]');
    this.frameHolder = this.querySelector('[data-lightbox-frame]');
    this.querySelector('[data-explorug-open]')?.addEventListener('click', (event) => {
      if (this.dataset.mode === 'new_tab') {
        window.open(this.dataset.url, '_blank', 'noopener');
        return;
      }
      this.open(event.currentTarget);
    });
    if (!this.dialog) return;
    this.dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-lightbox-close]') || event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  open(trigger) {
    this.trigger = trigger;
    const url = this.dataset.url;
    if (!url || !this.dialog || !this.frameHolder) return;
    /* 226 — ONE open() serves the Explorug viewer, the trade design tool AND the
       booking lightbox, so the event is chosen here rather than at five call
       sites. The booking instance is the one carrying data-calendly-lightbox. */
    try {
      if (window.drTrack) {
        const ctx = document.documentElement.dataset.tradeContext === 'true' ? 'trade' : 'retail';
        if (this.hasAttribute('data-calendly-lightbox')) {
          const t = trigger || {};
          const inNav = !!(t.closest && t.closest('nav, .mega-nav, .nav-drawer, .site-header, .site-footer'));
          const surface = (window.__dr || {}).surface;
          let source = 'other';
          if (inNav) source = 'menu';
          else if (surface === 'product') source = 'pdp';
          else if (/book-a-consultation/.test(location.pathname)) source = 'book-page';
          else if (/contact/.test(location.pathname)) source = 'contact';
          window.drTrack('dr_book_consultation_open', { source: source, context: ctx });
        } else {
          window.drTrack('dr_view_in_room', {
            context: ctx,
            tool: this.dataset.tool || 'view-in-room',
            product_handle: (window.__dr || {}).handle || null,
          });
        }
      }
    } catch (e) { /* analytics must never block the lightbox */ }

    /* The visualiser takes 1.5–4s to boot and spends part of that on
       its own "Setting up a secured connection…" screen. Unannounced, that
       reads as a broken lightbox (it is what the embed was withdrawn for in
       ). Show our own loading state until the frame commits, and keep a
       watchdog so a genuine failure offers the new tab instead of hanging.*/
    /* EVERYTHING GATED ON `recovery` BELOW IS EXPLORUG-ONLY.
       It exists because Explorug fails undetectably. Calendly
       loads reliably, so on that modal a loading state, a watchdog and a
       "taking a while?" strip are noise — and an escape hatch reads as a
       warning. Default is a plain lightbox; Explorug opts in.*/
    const recovery = this.dataset.recovery === 'true';

    let loader = null;
    if (recovery) {
      loader = document.createElement('div');
      loader.className = 'explorug-lightbox__loading';
      loader.setAttribute('role', 'status');
      loader.textContent = this.dataset.loadingText || 'Loading the room view…';
    }

    const frame = document.createElement('iframe');
    frame.src = url;
    frame.title = this.frameHolder.dataset.frameTitle || 'View in a Room';
    frame.loading = 'eager';
    /* Camera → the visualiser's "My Room" capture; storage-access → lets the
       app request storage itself under partitioning. Both are permissions we
       GRANT, not behaviour we can force. requested only where they are
       actually used — a booking widget has no business asking for a camera.*/
    frame.allow = recovery ? 'camera; storage-access; fullscreen' : 'fullscreen';

    clearTimeout(this.watchdog);
    let settled = false;
    const settle = () => {
      settled = true;
      clearTimeout(this.watchdog);
      if (loader) loader.remove();
    };
    /* Measured: exactly ONE load event, at ~2.8s (the account-host → v3-host
       redirects complete before it fires). The app is then usable somewhere
       between 1.5s and 4s. A long grace would hide an already-usable app, so
       it is short — just enough to cover the handover.

       ⚠ the load event is NOT proof of success. Explorug's own
       "Oops… it's us" error page arrives as a normal 200 document and fires
       this same event, and the frame is cross-origin, so failure is
       UNDETECTABLE from here. The loader below only covers the boot gap;
       the timed hint (further down) is the user's manual out.*/
    frame.addEventListener('load', () => {
      clearTimeout(this.grace);
      this.grace = setTimeout(settle, 600);
    });
    frame.addEventListener('error', () => {
      /* A genuine network-level failure (the only kind we CAN see)*/
      clearTimeout(this.watchdog);
      if (!loader) return;
      loader.classList.add('explorug-lightbox__loading--slow');
      loader.textContent =
        this.dataset.slowText ||
        'The room view could not load here. You can open it in a new tab instead.';
    });

    /* The "taking a while?" strip, ~8s after opening, UNCONDITIONALLY:
       framed boots run ~18-20s when they work at all, and when they fail we
       cannot tell. Dismissible, and it never covers the frame.*/
    const hint = recovery ? this.dialog.querySelector('[data-lightbox-hint]') : null;
    if (hint) {
      hint.hidden = true;
      clearTimeout(this.hintTimer);
      this.hintTimer = setTimeout(() => {
        hint.hidden = false;
      }, 8000);
      hint.querySelector('[data-hint-close]')?.addEventListener('click', () => {
        hint.hidden = true;
      }, { once: true });
    }
    if (recovery) {
      this.watchdog = setTimeout(() => {
        if (settled || !loader) return;
        loader.classList.add('explorug-lightbox__loading--slow');
        loader.textContent =
          this.dataset.slowText ||
          'The room view is taking longer than usual. You can open it in a new tab instead.';
      }, 12000);
    }

    this.frameHolder.replaceChildren(...(loader ? [loader, frame] : [frame]));
    this.dialog.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.trapFocus(this.dialog, this.dialog.querySelector('[data-lightbox-close]'));
  }

  close() {
    if (!this.dialog) return;
    clearTimeout(this.watchdog);
    clearTimeout(this.grace);
    clearTimeout(this.hintTimer);
    const hint = this.dialog.querySelector('[data-lightbox-hint]');
    if (hint) hint.hidden = true;
    this.dialog.hidden = true;
    this.frameHolder.replaceChildren(); // unload the visualiser
    document.documentElement.style.overflow = '';
    window.removeTrapFocus(this.trigger || null);
  }
}
if (!customElements.get('explorug-lightbox')) customElements.define('explorug-lightbox', ExplorugLightbox);
}

